import { ModelTimestamps } from './base.model';
import { IElementID, ProjectID } from './project.model';

export type ICommentID = string;

export enum CommentAsyncStatus {
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
  Error = 'ERROR',
}

export type IComment = ModelTimestamps & {
  id: ICommentID;
  project_id: ProjectID;
  element_id?: IElementID;
  owner: string;
  message: string;
  async_status: CommentAsyncStatus;
};

export type CommentGroupChange = {
  ids: ICommentID[];
} & ({ action: 'edit'; message: string } | { action: 'delete' | 'restore' });
